<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-10-26 09:40:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-10-07 21:43:01
-->
<template>
    <div class="user_nav_box">
        <ul>
            <li>
                <router-link :to="`/Center`">
                    會員中心
                </router-link>
            </li>
            <li>
                <router-link :to="`/UserInfo`">
                    我的資料
                </router-link>
            </li>
            <li>
                <router-link :to="`/Password`">
                    修改密碼
                </router-link>
            </li>
            <li>
                <router-link :to="`/Cart`">
                    購物車
                </router-link>
            </li>
            <li>
                <router-link :to="`/OrderList`">
                    訂單信息
                </router-link>
            </li>
            <li v-if="user_data.user_l == user_data.user_chu">
                <router-link :to="`/MyPrice`">
                    我的價格
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
// 辅助函数，可以使用命名空间获取$store的数据
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState("loginUser", ["user_data", "islogining"]),
    },
};
</script>

<style scoped lang="scss">
.user_nav_box {
    width: 138px;
    float: left;
    z-index: 1;
    overflow: hidden;
    position: relative;
    top: 0;
    left: 0;
    padding: 20px 10px;
    border: 1px solid #e4e4e4;
    background: #fff;
    li {
        a {
            color: #333;
            display: block;
            height: 16px;
            cursor: pointer;
            line-height: 1;
            margin-bottom: 15px;
            font-size: 14px;
        }
        a:hover {
            color: #ff2832;
        }
    }
}
.router-link-exact-active {
    color: #ff2832 !important;
}
</style>
